module.exports = __webpack_public_path__ + "img/contactBanner.1be34f01.png";